/**
 * Borrow this from Wang.Qiong on 2021/9/11.
 * Modify by Wang.chen on 2022/7/19.
 */
import React, { useState, useEffect } from 'react'
import { Modal, Input, Button, Table, message, Empty, Form } from 'antd';
import '../../New/new.scss'
const { TextArea } = Input;
function RecruitDetail(props) {
    useEffect(() => {

    }, [props])
    return (
        <div >
            <Modal
                className='changeNew'
                title="详情"
                centered
                visible={props.particularsVisible}
                onCancel={() => props.handleParticularsVisible(false)}
                width={900}
                height={400}
                footer={[
                    <Button onClick={() => props.handleParticularsVisible(false)} style={{ background: '#0093D8', color: '#fff' }}>
                        取消
                    </Button>
                ]}
            >

                <h1>{props.particularsContent?.positionName}</h1>
                <p >{'发布时间:'+props.particularsContent?.recordtime}</p>
                <p >{'薪资:'+props.particularsContent?.wage}</p>
                <p >{'人数:'+props.particularsContent?.numbers}</p>
                <p >{'地址:'+props.particularsContent?.address}</p>
                <p >{'职位描述:'}<div className='new_content' dangerouslySetInnerHTML={{ __html: props.particularsContent?.positionContext }}></div></p>
                <p >{'任职要求:'}<div className='new_content' dangerouslySetInnerHTML={{ __html: props.particularsContent?.positionRequirements }}></div></p>
                
                
            </Modal>

        </div>
    )

}
export default RecruitDetail;
